<ds-card-number-input
  class="w-100"
  [formControl]="formControl"
  [label]="props.label || 'Debit/Credit card number'"
  [helper]="helper"
  [error]="error"
  [inputId]="id"
/>
<formly-validation-message *ngIf="showError" class="d-none" [field]="field" />
